import(/* webpackMode: "eager" */ "/rdhrtdshgser/app/global-error.tsx");
